import { Drawer as DrawerPrimitive } from 'vaul';


const DrawerPortal = DrawerPrimitive.Portal;

export { DrawerPortal };
